import React from "react";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings";
import { Outlet } from "react-router-dom";

const Heading = tw(
  SectionHeading,
)`tw-w-full tw-text-left tw-mb-8 tw-text-gray-100`;

const HeroContainer = tw.div`tw-absolute tw-top-0 tw-left-0 tw-w-screen tw-h-screen -tw-ml-8 -tw-mt-32 -tw-z-50`;
const Hero = tw.div`tw-bg-primary-800 tw-w-full tw-h-[600px] sm:tw-h-[550px]`;
const InformationContainerParent = tw.div`tw-pt-[]`;

export default ({ firstName, children }) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeroContainer>
          <Hero></Hero>
        </HeroContainer>
        <InformationContainerParent>
          <Heading>Welcome {firstName} &#128075;</Heading>
          {children}
        </InformationContainerParent>
      </ContentWithPaddingXl>
    </Container>
  );
};
